import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { authService } from "../services/authService";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPageTurning, setIsPageTurning] = useState(false);
  const [registrationsEnabled, setRegistrationsEnabled] = useState(true);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setIsPageTurning(true);
    const timer = setTimeout(() => setIsPageTurning(false), 600);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  useEffect(() => {
    const check = async () => {
      try {
        const data = await authService.getRegistrationsSetting();
        setRegistrationsEnabled(!!data.registrations_enabled);
      } catch {
        setRegistrationsEnabled(true);
      }
    };
    check();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate("/exams");
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="auth-page">
      <Link to="/" className="logo-link">
        <img src="/logos/examcat_logo.png" alt="Examcat" className="logo" />
      </Link>
      <div className={`book-container ${isPageTurning ? "page-turning" : ""}`}>
        <div className="book-left-page">
          <div className="notebook-lines">
            {Array.from({ length: 20 }).map((_, i) => (
              <div key={i} className="notebook-line"></div>
            ))}
          </div>
        </div>
        <div className="book-spine"></div>
        <div className="book-right-page">
          <div className="auth-form-container">
            <h2>Iniciar Sesión</h2>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Contraseña:</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="submit-button"
              >
                {loading ? "Iniciando sesión..." : "Iniciar Sesión"}
              </button>
            </form>
            {registrationsEnabled && (
              <p className="register-link">
                Don't have an account? <Link to="/register">Sign up here</Link>
              </p>
            )}
            <p className="register-link">
              <Link to="/password-reset">Forgot your password?</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
